import axios from "axios";
import {
  baseUrl,
  postOptions,
} from "../config.js";
class ContestService {
  constructor(baseUrl) {
    this.basePath = "/contest";
    this.baseUrl = `${baseUrl}${this.basePath}`;
  }

  entryContest(data) {
    return axios(postOptions(this.baseUrl, `/entry`, data));
  }
}

export default new ContestService(baseUrl);  //eslint-disable-line import/no-anonymous-default-export
